<template>
<div id="19_ap_secciones_aduaneras" >
    <v-power-catalogo :parametros="parametros" />
</div>
</template>

<script>
import powerCatalogo from "@/views/apendices/layout.vue";
export default {
    components: {
        "v-power-catalogo": powerCatalogo
    },
    mounted() {},

    data: () => ({
        fab: false,
        parametros: {
            url_actions: "apendices/",
            url_list: "apendices/lista/",
            tabla: 19,
            title: "SECCIONES ADUANERAS",
            columns: ["aduana", "seccion", "descripcion", "actions"],
            options: {
                filterable: ["aduana", "seccion", "descripcion"],
                sortable: ["aduana", "seccion", "descripcion"],

                headings: {
                    aduana: "Aduana",
                    seccion: "Sección",
                    descripcion: "Descripción",
                    actions: "Operaciones"
                }
            },
            camposexcel: {
                Aduana: "aduana",
                Sección: "seccion",
                Descripción: "descripcion"
            },
            encabezadoLayout: {
                aduana: "aduana",
                seccion: "seccion",
                descripcion: "descripcion"
            },
            camposLayout: [{
                aduana: "[Clave Aduana]",
                seccion: "[Clave Sección]",
                descripcion: "[Descripción de la Seccion Aduanera]"
            }],
            model: {
                id: 0,
                aduana: "",
                seccion: "",
                descripcion: ""
            },
            form: {
                aduana: {
                    requiered: true,
                    label: "Aduana",
                    value: "",
                    maxlen: 2
                },
                seccion: {
                    requiered: true,
                    label: "Sección",
                    value: "",
                    maxlen: 1
                },
                descripcion: {
                    requiered: true,
                    label: "Descripción",
                    value: "",
                    maxlen: 200
                }
            },
            breadcrumbs: [{
                    text: "Inicio",
                    disabled: false,
                    to: "/home"
                },
                {
                    text: "Utilerías",
                    disabled: true,
                    to: ""
                },
                {
                    text: "Apendices",
                    disabled: true,
                    to: ""
                }
            ]
        }
    })
};
</script>
<style scoped>
.VueTables >>> thead th {
  white-space: normal !important;
}

.VueTables >>> tbody td{
  white-space: normal !important;
}
</style>